












































































import VueOptions from '@utils/VueOptions'
import UiList from '@superUI/List/List'
import Modal from '@/components/Modal'
import Trigger from '@modules/ui/triggers/Trigger'
import ResourceList from '@modules/ui/List/ResourceList'
import InvoiceResourceListFilters from '@superUI/ResourceList/InvoiceResourceListFilters'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'PuchaseResourceList'

  vue:
    props: ['invoices', 'bulkActionResultItems', 'actions', 'filtersOverriden', 'infiniteWrapper', 'options']
    components: {
      UiList,
      Modal,
      Trigger,
      ResourceList,
      InvoiceResourceListFilters,
      LoadingIndicator
    }

    data: ->
      activeFilter: false
      pageNumber: 1

      sortList: [
        { field: 'number', value: 'PO Number' }
        { field: 'created_at', value: 'Created At' }
      ]
      sortValue: ''

      filters:
        scopes:
          sent: null
          unsent: null
        q: ''
        sort: [{ field: 'created_at', order: 'desc' }]

        filters:
          resolved_after: ''
          resolved_before: ''

        sort: [{ field: 'ctx.resolved_at', order: 'desc' }]

      selectedFilters: []
      selectedInvoices: []
      rowSize: 3

      sortList: [
        { field: 'ctx.resolved_at', value: 'Date' }
        { field: 'created_at', value: 'Created At' }
      ]
      sortValue: ''

    mounted: ->
      @filters = @filtersOverriden if @filtersOverriden?

    computed:
      components: ->
        {
          'invoice-resource-list-item': () => import('./InvoiceResourceListItem')
        }
      title: ->
        @options?.title || 'Invoices'

      resourceKey: ->
        @options?.resourceKey || 'invoices'

      availableSort: ->
        ctx = this
        availableList = @sortList.filter((sort) ->
          item = ctx.filters.sort.find((item) -> item.field == sort.field)
          !item
        )
        availableList

    methods:
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @formatFiltersPayload(), { page: @pageNumber })
        @pageNumber += 1

      hiFilterChange: (selectedFilters) ->
        @$refs.infiniteLoading.stateChanger.reset()
        @selectedFilters = selectedFilters if selectedFilters
        @pageNumber = 1
        filtersPayload = @formatFiltersPayload()
        @actions.fetchResource(null, @resourceKey, filtersPayload, { page: @pageNumber })
        @pageNumber += 1

      formatFiltersPayload: ->
        payload = {...@filters}

        timeWindows = payload.filters
        for field, timeWindow of timeWindows
          delete timeWindows[field] if not timeWindow

        payload

      hiSearchChange: (q = '') ->
        @filters.q = q
        @hiFilterChange(@filters)

      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @selectedFilters = []
        @hiFilterChange(@filters)

      hiAddSort: (order) ->
        return false if !@sortValue.length
        @filters.sort.push({ field: @sortValue, order })
        @hiFilterChange()
        @sortValue = ''

      hiRemoveSort: (sort) ->
        @filters.sort = @filters.sort.filter((item) -> item.field != sort.field)
        @hiFilterChange()

      hiFlipOrder: (sort) ->
        flippedOrder = if sort.order == 'asc' then 'desc' else 'asc'
        @filters.sort = @filters.sort.filter((item) ->
          item.order = flippedOrder if item.field == sort.field
          item
        )
        @hiFilterChange()

      sortOrderIcon: (order) ->
        if order == 'asc'
          return 'fa-arrow-up'

        return 'fa-arrow-down'

      getFieldName: (field) ->
        @sortList.find((item) -> item.field == field).value

      hiDownloadInvoiceCSV: (invoice) ->
        @actions.downloadInvoiceCSV invoice

      hiToggleDeliveryFlag: (invoice) ->
        @actions.toggleDeliveryFlagTrigger(invoice)

export default VueOptions.vue settings
